import SmoothScroll from 'smooth-scroll'

class FiltersMainSection {
  form: HTMLFormElement

  constructor(form: HTMLFormElement) {
    this.form = form
  }

  scrollToFilters() {
    const button = this.form.querySelector('.js-search-yachts-button')
    const filtersWithSidebar = this.form.querySelector('.js-filters-with-sidebar')

    if (button && filtersWithSidebar) {
      const scroll = new SmoothScroll()

      button.addEventListener('click', e => {
        e.preventDefault()
        scroll.animateScroll(filtersWithSidebar)
      })
    }
  }
}

export default FiltersMainSection
